import {$authHost, $host} from "./index";
import {jwtDecode} from "jwt-decode";

export const registration = async (email, password, username, recaptchaToken, referrer_id = null) => {
    const deviceId = localStorage.getItem("deviceId"); // Берём из localStorage

    const { data } = await $host.post(
        "api/user/registration",
        { email, password, username, recaptchaToken, referrer_id },
        {
            headers: {
                "X-Device-ID": deviceId || "", // Передаём deviceId, если он есть
            },
            withCredentials: true, // Передаём куки
        }
    );

    localStorage.setItem("token", data.token);
    return jwtDecode(data.token);
};

// ✅ для обычной регистрации с e-mail (без JWT в ответе)
export const preRegistration = async (email, password, username, recaptchaToken, referrer_id = null) => {
    const deviceId = localStorage.getItem("deviceId") || "";
    const res = await $host.post(
        "/api/user/registration",
        { email, password, username, recaptchaToken, referrer_id },
        { headers: { "X-Device-ID": deviceId }, withCredentials: true }
    );
    return res.data; // например: { status: 'VERIFY_EMAIL_SENT' }
};

export const forgotPassword = async (email) => {
    const {data} = await $host.post('api/user/forgot-password', {email})
    return (data)
}

// для подтверждения и ресенда
export const verifyEmail = async (ceToken) => {
    const { data } = await $host.post('/api/user/check-verification-email-token', {ceToken})
    if (data?.token) localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
};

export const resendVerification = async (email) => {
    const { data } = await $host.post("/api/user/resend-verification-email", { email });
    return data;
};

export const resetPassword = async (resetToken, newPassword) => {
    const {data} = await $host.post('api/user/reset-password', {resetToken, newPassword})
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
};

export const login = async (email, password, recaptchaToken) => {
    const {data} = await $host.post('api/user/login', {email, password, recaptchaToken})
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const check = async () => {
    const {data} = await $authHost.get('api/user/auth' )
    localStorage.setItem('token', data.token)
    return jwtDecode(data.token)
}

export const googleLoginSendToken = async (googletoken, referrer_id = null) => {
    const { data } = await $host.post("api/user/google-login", { googletoken, referrer_id });
    localStorage.setItem("token", data.token);
    return jwtDecode(data.token);
};

export const fetchPaymentSession = async (userId, email, price_id, pc) => {
    const {data} = await $host.post('api/payment/create-checkout-session', {userId, email, price_id, pc})
    return (data)
}

export const fetchPromoPaymentSession = async (userId, email, price_id, couponId) => {
    const {data} = await $host.post('api/payment/create-promo-checkout-session', {userId, email, price_id, couponId})
    return (data)
}

export const fetchAddFundsPaymentSession = async (userId, email, price_id) => {
    const {data} = await $host.post('api/payment/create-add-funds-checkout-session', {userId, email, price_id})
    return (data)
}

export const createPaymentIntent = async () => {
    const {data} = await $host.post('api/payment/create-payment-intent',  {})
    return data
}

export const fetchPaymentSessionStatus = async (sessionId) => {
    try {
        const { data } = await $host.get(`api/payment/session-status`, {
            params: { session_id: sessionId }
        });
        return data;
    } catch (error) {
        console.error('Ошибка при получении статуса сессии:', error);
        return null;
    }
};

export const fetchPaymentConfig = async ( ) => {
    try {
        const { data } = await $host.get(`api/payment/config`,
        );
        return data;
    } catch (error) {
        console.error('Error', error);
        return null;
    }
};

export const updateUserDataFront = async (
    id,
    email,
    newPassword,
    username,
    amz_name,
    audible_name,
    hold_start_date,
    amz_country,
    audible_country,
    // новые поля анкеты:
    sex,
    age,
    income,
    education,
    fiction_genres,      // массив строк
    nonfiction_genres,   // массив строк
    occupation
) => {
    const res = await $authHost.post('api/user/update', {
        id,
        email,
        newPassword,
        username,
        amz_name,
        audible_name,
        hold_start_date,
        amz_country,
        audible_country,
        // 👇 добавили новые поля
        sex,
        age,
        income,
        education,
        fiction_genres,
        nonfiction_genres,
        occupation,
    });

    const data = res?.data ?? {};

    if (data.token) {
        localStorage.setItem('token', data.token);
    }

    return data; // { token?, message? }
};

export const fetchReviewerProfilesOverviewApi = async () => {
    const { data } = await $authHost.get('api/user/reviewer-profiles');
    return data;
};

export const createReviewerProfileChangeRequestApi = async ({
    request_type,
    target_profile_id = null,
    requested_payload = {},
}) => {
    const { data } = await $authHost.post('api/user/reviewer-profile-change-request', {
        request_type,
        target_profile_id,
        requested_payload,
    });
    return data;
};

export const setDefaultReviewerProfileApi = async (profileId) => {
    const { data } = await $authHost.post(`api/user/reviewer-profiles/${profileId}/set-default`);
    return data;
};

export const adminFetchReviewerProfileChangeRequestsApi = async ({ status = 'PENDING', page = 1, limit = 50 } = {}) => {
    const { data } = await $authHost.get('api/user/admin/reviewer-profile-change-requests', {
        params: { status, page, limit },
    });
    return data;
};

export const adminApproveReviewerProfileChangeRequestApi = async (id, staff_comment = '') => {
    const { data } = await $authHost.post(`api/user/admin/reviewer-profile-change-requests/${id}/approve`, {
        staff_comment,
    });
    return data;
};

export const adminRejectReviewerProfileChangeRequestApi = async (id, staff_comment = '') => {
    const { data } = await $authHost.post(`api/user/admin/reviewer-profile-change-requests/${id}/reject`, {
        staff_comment,
    });
    return data;
};

// 1) Временная загрузка скриншота (→ photo_temp)
export const uploadPromoTemp = async (file) => {
    const fd = new FormData();
    fd.append("photo", file); // <-- одно изображение
    const { data } = await $authHost.post("/api/assignment/promo_bounty/temp", fd, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    // -> { message, uploadedFile, fileHash }
    return data;
};

// 2) Создать заявку (перенос файла в постоянную папку + запись в БД)
export const createPromoBountyRequestApi = async ({
                                                      userId,
                                                      postUrl,
                                                      isActiveLinkClaimed,
                                                      isVideo,
                                                      note,
                                                      tempFileName, // из uploadPromoTemp().uploadedFile
                                                      fileHash,     // из uploadPromoTemp().fileHash (опционально)
                                                  }) => {
    const payload = {
        user_id: userId,
        post_url: postUrl,
        isActiveLinkClaimed: !!isActiveLinkClaimed,
        isVideo: !!isVideo,
        note: note || "",
        screenshot: { fileName: tempFileName, hash: fileHash || null },
    };
    const { data } = await $authHost.post("/api/assignment/promo_bounty/create", payload);
    // -> { message, request }
    return data;
};

// 3) Получить список заявок пользователя
export const fetchPromoBountyRequestsApi = async (userId) => {
    const { data } = await $authHost.get("/api/assignment/promo_bounty/list", {
        params: { user_id: userId },
    });
    // -> { requests: [...] }
    return data;
};

// 4) (Опционально, админ) Модерация заявки
export const moderatePromoBountyApi = async ({
                                                 id,
                                                 status, // 'approved' | 'rejected' | 'pending'
                                                 verified_active_link,
                                                 verified_video_authorship,
                                                 moderator_note,
                                                 override_final_payout, // число (опц.)
                                             }) => {
    const payload = {
        id,
        status,
        verified_active_link: !!verified_active_link,
        verified_video_authorship: !!verified_video_authorship,
        moderator_note: moderator_note || "",
        override_final_payout,
    };
    const { data } = await $authHost.post("/api/assignment/promo_bounty/moderate", payload);
    // -> { message, promo_bounty }
    return data;
};

export const fetchPromoBountyAllApi = async ({ status, q, page = 1, limit = 20 } = {}) => {
    const { data } = await $authHost.get('/api/assignment/promo_bounty/all', {
        params: { status, q, page, limit },
    });
    return data;
};

export const createDashboardPromotionProofApi = async ({
                                                           promotionKey,
                                                           promotionTitle,
                                                           proofText,
                                                           tempFileName,
                                                           fileHash,
                                                       }) => {
    const payload = {
        promotion_key: promotionKey,
        promotion_title: promotionTitle || "",
        proof_text: proofText || "",
        screenshot: { fileName: tempFileName, hash: fileHash || null },
    };
    const { data } = await $authHost.post("/api/assignment/dashboard_promotion_proofs/create", payload);
    return data;
};

export const fetchDashboardPromotionProofsApi = async (promotionKey) => {
    const { data } = await $authHost.get("/api/assignment/dashboard_promotion_proofs/list", {
        params: { promotion_key: promotionKey },
    });
    return data;
};

export const fetchDashboardPromotionProofsAllApi = async ({ promotionKey, status, q, page = 1, limit = 20 } = {}) => {
    const { data } = await $authHost.get("/api/assignment/dashboard_promotion_proofs/all", {
        params: {
            promotion_key: promotionKey,
            status,
            q,
            page,
            limit,
        },
    });
    return data;
};

export const moderateDashboardPromotionProofApi = async ({ id, status, moderator_note }) => {
    const { data } = await $authHost.post("/api/assignment/dashboard_promotion_proofs/moderate", {
        id,
        status,
        moderator_note: moderator_note || "",
    });
    return data;
};

export const updateUserVirtBalancePollDoneApi = async (userId, pollItemId) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-poll-done`, {
        pollItemId
    });
    return data;
};

export const updateUserVirtBalanceAssignmentCreateApi = async (userId, bookId, deductAmount) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-assignment-create`, {
        bookId, deductAmount
    });
    return data;
};

export const updateUserVirtBalanceCancelAssignmentByOwnerApi = async (userId, assignmentId) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-cancel-assignment-by-owner`, {
        assignmentId
    });
    return data;
};

export const updateUserVirtBalanceTakeAssignmentFromLibraryApi = async (userId, assignmentId, bonusAmount, reviewerProfileId = null) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-take-assignment-from-library`, {
        assignmentId,
        bonusAmount,
        reviewerProfileId,
    });
    return data;
};

export const updateUserVirtBalanceConfirmAsinAndSearchTermApi = async (assignmentId) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-confirm-asin-and-search-term`, {
        assignmentId
    });
    return data;
};

export const updateUserVirtBalanceCancelAssignmentApi = async (assignmentId, reason, reasonId) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-cancel-assignment`, {
        assignmentId, reason, reasonId
    });
    return data;
};

export const updateUserVirtBalanceRefundAssignmentApi = async (assignmentId) => {
    const { data } = await $authHost.post(`api/user/update-user-virt-balance-refund-assignment`, {
        assignmentId
    });
    return data;
};

export const sendTestEmailApi = async (to, subject, template, username, title, link, number) => {
    const { data } = await $authHost.post(`api/user/send-test-email-admin-use`, {
        to, subject, template, username, title, link, number
    });
    return data;
};

export const getRedirectUrlApi = async (targetUrl) => {
    const { data } = await $host.post(`api/user/full-redirect-go-to`, {
        targetUrl
    });
    return data;
};

export const getRedirectUrlApiGET = async (targetUrl) => {
    const { data } = await $host.get(`api/user/get-user-personal-redirect-to-amazon`, {
        params: { targetUrl }
    });
    return data;
};


export const updateAssignmentAuthorDataFront = async (id, balanceAddition, description) => {
    const { data } = await $authHost.post(`api/user/update-assignment-author`, {
        id, // ID ассигмента
        balanceAddition, // Сумма прибавки
        description // Описание
    });

   return data.newBalance; // ✅ Возвращаем обновленный баланс
};

export const updateAssignmentReviewerDataFront = async (id, balanceChange, description) => {
    const { data } = await $authHost.post(`api/user/update-assignment-reviewer`, {
        id, // ID ассигмента
        balanceChange, // Сумма
        description // Описание
    });

    return data.newBalance; // ✅ Возвращаем обновленный баланс
};

export const updateUserDataForPolls = async (userId, pollId, balanceChange, description, direction) => {
    const { data } = await $authHost.post(`api/user/update-user-polling`, {
        userId,
        pollId,
        balanceChange,
        description,
        direction // "Add" или "Reduce"
    });

    return data.newBalance; // ✅ Возвращаем обновленный баланс
};

export const getCustomerPortalUrl = async (customerId) => {
    try {
        const { data } = await $authHost.post('api/payment/customer-portal', { customerId });

        if (data.url) {
            return data.url; // ✅ Возвращаем URL
        } else {
            console.error("❌ Error: No portal URL received");
            return null;
        }
    } catch (error) {
        console.error("❌ Error opening Stripe Customer Portal:", error);
        return null;
    }
};

export const fetchReferredUsers = async (userId) => {
    const { data } = await $authHost.get('/api/user/referrals', {
        params: { user_id: userId }
    });
    return data;
};

export const fetchUsersCountryPie = async () => {
    const { data } = await $host.get('/api/user/country-pie');
    return data;
};

export const updateUserDataAdminFront = async (userData) => {
    const { data } = await $authHost.post(`api/user/update-user-data`, userData);
    return data;
};

export const deleteUserAccount = async (del) => {
    const { data } = await $authHost.post(`api/user/delete-user-account`, del);
    return data;
};

export const deductUserBalance = async (id, amount) => {
    const { data } = await $authHost.post(`api/user/deduct-balance`, {
        id,
        amount,
    });
    return data.newBalance; // ✅ Возвращаем обновленный баланс
};

export const userVirtBalanceChangeApi = async (userId, amount, message) => {
    const { data } = await $authHost.post(`api/user/change-virt-balance-adm`, {
        userId,
        amount,
        message,
    });
    return data; // ✅ Возвращаем обновленный баланс
};

export const userBalanceChangeApi = async (
    userId,
    amountVirt,
    amountUsd,
    amountTrust,
    amountAff,
    message
) => {
    const { data } = await $authHost.post(`api/user/change-virt-usd-trust-aff-adm`, {
        userId,
        amountVirt,
        amountUsd,
        amountTrust,
        amountAff,
        message,
    });
    return data;
};

export const requestTransferVirtToAnotherAccountApi = async (orderData) => {
    const { userId, ...payload } = orderData || {};
    const { data } = await $authHost.post(`api/user/transfer-virt-to-another-account`, payload);
    return data;
};

export const confirmCodeToTransferVirtApi = async (orderData) => {
    const { data } = await $authHost.post(`api/user/transfer-virt-to-another-account-confirm`, orderData);
    return data;
};

export const fetchTransferVirtToAnotherAccountApi = async (userId, opts = {}) => {
    const { limit, offset } = opts;
    const params = new URLSearchParams();
    if (typeof limit === 'number') params.append('limit', String(limit));
    if (typeof offset === 'number') params.append('offset', String(offset));

    const { data } = await $authHost.get(
        `api/user/get-user-transfer-virt-to-another-account/me${params.toString() ? `?${params.toString()}` : ''}`
    );
    return data;
};

// Все внутренние переводы (админ)
export const getAllVirtTransfers = async (params = {}) => {
    // params: { page, limit, status, q }
    const { page = 1, limit = 50, status, q } = params;

    const query = new URLSearchParams();
    query.set("page", page);
    query.set("limit", limit);
    if (status) query.set("status", status);
    if (q) query.set("q", q);

    // Если у тебя для админских ручек используется $authHost — замени тут на него
    const { data } = await $authHost.get(`/api/user/admin/virt-transfers?${query.toString()}`);
    // ожидается { items: [...], count: 123 }
    return data;
};

// Отмена (реверс) внутреннего перевода админом
export const cancelVirtTransfer = async (transferId, payload = {}) => {
    const { data } = await $authHost.post(
        `/api/user/admin/virt-transfers/${transferId}/cancel`,
        payload
    );
    return data; // ожидаем { item: {...} }
};

// Создать заявку на продажу виртов
export const createSellVirtOrderApi = async (userId, virt_amount, usd_amount, price_virt_per_usd, comment = null) => {
    const { data } = await $authHost.post(`api/user/sell-virt-order-create`, {
        virt_amount,
        usd_amount,
        price_virt_per_usd,
        comment
    });
    return data; // ожидаем { message, order }
};

export const getSellVirtOrdersByUserIdApi = async (
    userId,
    opts = {} // { status?: 'available'|'completed'|'canceled'|'expired', limit?: number, offset?: number }
) => {
    const { status, limit, offset } = opts;

    const params = new URLSearchParams();
    if (status) params.append('status', status);
    if (typeof limit === 'number') params.append('limit', String(limit));
    if (typeof offset === 'number') params.append('offset', String(offset));

    const url = `api/user/sell-virt-orders-by-user-id/me${params.toString() ? `?${params.toString()}` : ''}`;

    const { data } = await $authHost.get(url);
    return data; // { count, rows, marketAverage: { trades_count, avg_virt_per_usd, avg_usd_per_1000_virt } }
};

export const updateSellVirtOrderStatusApi = async ({ action, orderId, userId, comment = null }) => {
    const { data } = await $authHost.put(`api/user/sell-virt-order-status`, {
        action,        // 'cancel' | 'buy'
        orderId,       // number
        comment,       // optional
    });
    return data; // { message, order }
};

// Удобные шорткаты:

// Отменить свой ордер
export const cancelSellVirtOrderApi = async ({ orderId, userId, comment = null }) => {
    return updateSellVirtOrderStatusApi({ action: 'cancel', orderId, userId, comment });
};

// Купить ордер
export const buySellVirtOrderApi = async ({ orderId, userId, comment = null }) => {
    return updateSellVirtOrderStatusApi({ action: 'buy', orderId, userId, comment });
};

// Получить все доступные ордера (available) для покупки
export const getAvailableSellVirtOrdersApi = async ({ limit = 50, offset = 0 } = {}) => {
    const params = new URLSearchParams();
    params.append("limit", String(limit));
    params.append("offset", String(offset));

    const { data } = await $authHost.get(`api/user/sell-virt-orders-available?${params.toString()}`);
    return data; // { count, rows }
};

export const fetchEmailSettingsApi = async () => {
    const { data } = await $authHost.get(`api/user/email-settings`);
    return data; // { settings: {...} }
};

export const updateEmailSettingsApi = async (settings) => {
    const { data } = await $authHost.put(`api/user/email-settings`, { settings });
    return data; // { message: 'Email settings saved', settings: {...} }
};

export const fetchPublicEmailSettingsApi = async ({ uid, token }) => {
    const { data } = await $host.get(`api/user/email-settings/public`, {
        params: { uid, token },
    });
    return data;
};

export const updatePublicEmailSettingsApi = async ({ uid, token, settings }) => {
    const { data } = await $host.put(`api/user/email-settings/public`, {
        uid,
        token,
        settings,
    });
    return data;
};

export const adminUploadCampaignImageApi = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    const { data } = await $authHost.post(`api/user/admin/email-campaign/upload-image`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });
    return data;
};

export const adminFetchEmailCampaignsApi = async (params = {}) => {
    const query = new URLSearchParams();
    if (params.limit) query.set("limit", String(params.limit));
    const { data } = await $authHost.get(`api/user/admin/email-campaign/campaigns?${query.toString()}`);
    return data;
};

export const adminSaveEmailCampaignApi = async (payload = {}) => {
    const { data } = await $authHost.post(`api/user/admin/email-campaign/campaigns`, payload);
    return data;
};

export const adminFetchEmailCampaignRecipientsApi = async (params = {}) => {
    const query = new URLSearchParams();
    if (params.limit) query.set("limit", String(params.limit));
    if (params.tariffPlan) query.set("tariffPlan", String(params.tariffPlan));
    if (params.mode) query.set("mode", String(params.mode));
    if (params.campaignKey) query.set("campaignKey", String(params.campaignKey));
    if (params.skipAlreadySent !== undefined) query.set("skipAlreadySent", String(params.skipAlreadySent));
    const { data } = await $authHost.get(`api/user/admin/email-campaign/recipients?${query.toString()}`);
    return data;
};

export const adminSendEmailCampaignOneApi = async (payload = {}) => {
    const { data } = await $authHost.post(`api/user/admin/email-campaign/send-one`, payload);
    return data;
};

export const adminSendWeeklyDigestTestApi = async (payload = {}) => {
    const { data } = await $authHost.post(`api/user/admin/email-campaign/weekly-test`, payload);
    return data;
};

export const fetchVirtSellOrdersAdmin = async (params = {}) => {
    try {
        const {
            page = 1,
            limit = 50,
            q,

            order_status,
            statuses, // array | CSV string

            created_from,
            created_to,
            purchased_from,
            purchased_to,
        } = params;

        const query = new URLSearchParams();

        if (page)  query.set("page", String(page));
        if (limit) query.set("limit", String(limit));
        if (q && String(q).trim()) query.set("q", String(q).trim());

        if (order_status) query.set("order_status", String(order_status));

        if (Array.isArray(statuses)) {
            // CSV, чтобы не слать повторяющиеся ключи
            const csv = statuses.map(s => String(s).trim()).filter(Boolean).join(",");
            if (csv) query.set("statuses", csv);
        } else if (typeof statuses === "string" && statuses.trim()) {
            query.set("statuses", statuses.trim());
        }

        const isFiniteNumber = (v) => Number.isFinite(Number(v));
        if (isFiniteNumber(created_from))   query.set("created_from", String(created_from));
        if (isFiniteNumber(created_to))     query.set("created_to", String(created_to));
        if (isFiniteNumber(purchased_from)) query.set("purchased_from", String(purchased_from));
        if (isFiniteNumber(purchased_to))   query.set("purchased_to", String(purchased_to));

        const { data } = await $authHost.get(`api/user/admin/virt-sell-orders?${query.toString()}`);
        return data; // { items, count, page, limit }
    } catch (error) {
        console.error("Error fetching virt sell orders:", error);
        throw new Error(error?.response?.data?.message || "Failed to fetch virt sell orders");
    }
};

export const fetchAffiliatePayoutsAdmin = async (params = {}) => {
    try {
        const {
            page = 1,
            limit = 50,
            q,

            // order_status
            order_status,
            statuses, // array | CSV string

            // payment_status
            payment_status,
            pstatuses, // array | CSV string

            // dates (minutes since epoch OR Date)
            requested_from,
            requested_to,
            payment_from,
            payment_to,
        } = params;

        const toMinutes = (v) => {
            if (v == null) return undefined;
            if (v instanceof Date) return Math.floor(v.getTime() / 60000);
            if (Number.isFinite(v)) return Number(v);
            return undefined;
        };

        const query = new URLSearchParams();

        // pagination
        if (page)  query.set("page", String(page));
        if (limit) query.set("limit", String(limit));

        // search
        if (q && String(q).trim()) query.set("q", String(q).trim());

        // order statuses
        if (order_status) query.set("order_status", String(order_status));
        if (Array.isArray(statuses)) {
            const csv = statuses.map(s => String(s).trim()).filter(Boolean).join(",");
            if (csv) query.set("statuses", csv);
        } else if (typeof statuses === "string" && statuses.trim()) {
            query.set("statuses", statuses.trim());
        }

        // payment statuses
        if (payment_status) query.set("payment_status", String(payment_status));
        if (Array.isArray(pstatuses)) {
            const csv = pstatuses.map(s => String(s).trim()).filter(Boolean).join(",");
            if (csv) query.set("pstatuses", csv);
        } else if (typeof pstatuses === "string" && pstatuses.trim()) {
            query.set("pstatuses", pstatuses.trim());
        }

        // dates -> minutes
        const rf = toMinutes(requested_from);
        const rt = toMinutes(requested_to);
        const pf = toMinutes(payment_from);
        const pt = toMinutes(payment_to);
        if (Number.isFinite(rf)) query.set("requested_from", String(rf));
        if (Number.isFinite(rt)) query.set("requested_to", String(rt));
        if (Number.isFinite(pf)) query.set("payment_from", String(pf));
        if (Number.isFinite(pt)) query.set("payment_to", String(pt));

        const { data } = await $authHost.get(`api/user/admin/affiliate-pay-out-orders?${query.toString()}`);
        return data; // { items, count, page, limit }
    } catch (error) {
        console.error("Error fetching affiliate payouts:", error);
        throw new Error(error?.response?.data?.message || "Failed to fetch affiliate payouts");
    }
};

export const payAffiliatePayoutAdmin = async (id, payload = {}) => {
    if (!id) throw new Error('Missing payout id');
    const { data } = await $authHost.post(`api/user/admin/affiliate-pay-out-orders/${id}/pay`, payload);
    return data; // { ok: true, item }
};
